import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SubpageLayout from "@/components/SubpageLayout";
import { Emphasis } from "@/components/Prose";
import { CATEGORIES } from "@/pages/ressourcer";

const Ressourcer = () => (
  <SubpageLayout
    overline="TRAUMEBEVIDST UDVIKLING"
    title="Ressourcer"
    art="/brand/hero-dandelion.png"
    testId="page-ressourcer"
  >
    <Emphasis>Viden skal ikke kun være tilgængelig for de få.</Emphasis>
    <p className="mt-8 text-base leading-loose text-[#2F3338]/85">
      Her samler vi forskning, publikationer, levede erfaringer, podcasts, videoer, materialer og
      andre ressourcer, der kan bidrage med viden, perspektiver og konkrete redskaber.
    </p>
    <p className="mt-6 text-base leading-loose text-[#2F3338]/85">
      Vi ønsker at skabe plads til forskellige former for viden – forskningsbaseret, faglig,
      praksisbaseret og erfaringsbaseret – og gøre den tilgængelig for flere.
    </p>

    <div className="mt-16">
      {CATEGORIES.map((cat) => (
        <Link
          key={cat.slug}
          to={`/ressourcer/${cat.slug}`}
          data-testid={`resource-link-${cat.slug}`}
          className="group block border-b border-[#D6C2A6]/70 py-9 first:border-t"
        >
          <div className="flex items-baseline justify-between gap-6">
            <h2 className="font-serif text-2xl text-[#3F5A47] sm:text-3xl">{cat.title}</h2>
            <ArrowRight className="h-5 w-5 shrink-0 text-[#B46A45] transition-transform duration-300 group-hover:translate-x-1.5" />
          </div>
          <p className="mt-3 max-w-lg text-base leading-relaxed text-[#2F3338]/80">{cat.text}</p>
        </Link>
      ))}
    </div>
  </SubpageLayout>
);

export default Ressourcer;
